import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue')
        },
        {
          path: '/requirements-policy',
          name: 'Requirements Policy',
          component: () => import(/* webpackChunkName: "demo" */ './views/Others/PortalGuidelines.vue')
        },
        {
          path: '/change-password',
          name: 'Change Password',
          component: () => import(/* webpackChunkName: "demo" */ './views/Profile/ChangePassword.vue')
        },
        {
          path: '/applications',
          name: 'My Applications',
          component: () => import(/* webpackChunkName: "demo" */ './views/Applications/Applications.vue')
        },
        {
          path: '/letters',
          name: 'My Letters',
          component: () => import('./views/Letters/Letters.vue')
        },
        {
          path: '/verification-visit',
          name: 'Verification Visit',
          component: () => import('./views/VerificationVisit/VerificationVisit.vue')
        },
        {
          path: '/application-details/:id',
          name: 'Application Details',
          component: () => import('./views/Applications/ApplicationDetails.vue')
        },
        {
          path: '/pending-application/:code/:id',
          name: 'Pending Application',
          component: () => import('./views/Applications/PendingApplication/ApplicationForm.vue')
        },
        {
          path: '/new-application/:code',
          name: 'New Application',
          component: () => import('./views/Applications/NewApplication/ApplicationForm.vue')
        },
        {
          path: '/re-accreditation/check-payment',
          name: 'Re-Accreditation Payment Check Page',
          component: () => import('./views/Applications/NewApplication/Accreditation/AccreditationRrr.vue')
        },
        {
          path: '/new-advisory/check-payment',
          name: 'New Advisory Payment Check Page',
          component: () => import('./views/Applications/NewApplication/Advisory/AdvisoryRrr.vue')
        },
        {
          path: '/new-application-form/:code',
          name: 'New Application Form',
          component: () => import('./views/Applications/NewApplication/NewApplicationForm/NewApplicationForm.vue')
        },
        {
          path: '/payments',
          name: 'My Payments',
          component: () => import('./views/Payments/Payments.vue')
        },
        {
          path: '/notifications',
          name: 'Notifications',
          component: () => import('./views/Notifications/Notifications.vue')
        },
        {
          path: '/notifications/:slug',
          name: 'Notification Details',
          component: () => import('./views/Notifications/SingleNotification.vue')
        },
        {
          path: '/indexing',
          name: 'Indexing',
          component: () => import('./views/Indexing/Indexing.vue')
        },
        {
          path: '/indexing/:code',
          name: 'Indexing Details',
          component: () => import('./views/Indexing/IndexingDetails.vue')
        },
        {
          path: '/indexing/new-indexing/:year',
          name: 'Edit Indexing Details',
          component: () => import('./views/Indexing/PendingIndexing.vue')
        },
        {
          path: '/indexing/application-details/:id',
          name: 'Indexing Application Details',
          component: () => import('./views/Indexing/ApplicationDetail/ApplicationDetail.vue')
        }
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "demo" */ './views/Logout.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verification-payment',
      name: 'Verification Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Verification.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/accreditation-generate',
      name: 'Accreditation Payment Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Accreditation/AccreditationGenerate.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/accreditation-callback',
      name: 'Accreditation Payment Callback Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Accreditation/AccreditationCallback.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/accreditation/check-payment',
      name: 'Accreditation Payment Check Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Accreditation/AccreditationRrr.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/advisory-generate',
      name: 'Advisory Payment Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Advisory/AdvisoryGenerate.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/advisory-callback',
      name: 'Advisory Payment Callback Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Advisory/AdvisoryCallback.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/advisory/check-payment',
      name: 'Advisory Payment Check Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Advisory/AdvisoryRrr.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/application-form/:code',
      name: 'Application Form',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Application/ApplicationForm.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'School Login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Auth/Login/Login.vue')
        },
        {
          path: '/register',
          name: 'New School Account',
          component: () => import(/* webpackChunkName: "demo" */ './views/Auth/Register/Register.vue')
        },
        {
          path: '/password-reset',
          name: 'password reset',
          component: () => import(/* webpackChunkName: "demo" */ './views/PasswordReset.vue')
        },
        {
          path: '/update-password',
          name: 'Update Password',
          component: () => import(/* webpackChunkName: "demo" */ './views/UpdatePassword.vue')
        }
      ],
      meta: {
        requiresVisitor: true
      }
    },
    {
      path: '/requirements',
      name: 'Requirements',
      component: () => import(/* webpackChunkName: "demo" */ './views/Requirements/Requirements.vue'),
      meta: {
        requiresVisitor: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let saved = localStorage.getItem('time_out');// set access token
    let lockTime = localStorage.getItem('lock_time');// get lock time
    if(! lockTime) {// initiate profile lock function
      let hours = 3;
      localStorage.setItem('lock_time', new Date().getTime() + (hours * 60 * 60 * 1000));// set lock time
    }
    if (saved && (saved < new Date().getTime())) {//session time out
        localStorage.clear();
        window.location.reload();
    }
    if (! store.getters.isLoggedIn) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.isLoggedIn) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    next()
  }
});

export default router;
